/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const AFTER_SALES = 'AFTER_SALES';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
const APPLE_TV = 'APPLE_TV';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const CAMERA = 'CAMERA';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const CHAT = 'CHAT';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const SALES = 'SALES';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const TRACK = 'TRACK';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const AUDIT = 'AUDIT';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const APPOINTMENT = 'APPOINTMENT';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const SELF_SERVICE = 'SELF_SERVICE';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const PARTS = 'PARTS';
/** @type {import("modules/global/typing/enums/extensions.enum").ExtensionEnum} */
export const CAMPAIGN = 'CAMPAIGN';

export const EXTENSIONS = [AFTER_SALES, SALES, AUDIT, APPLE_TV, APPOINTMENT, CAMERA, CHAT, TRACK, SELF_SERVICE, PARTS, CAMPAIGN];

// DO NOT INCLUDE THOSE 2 VARIABLES IN EXTENSIONS ARRAY
export const DEFAULT = 'DEFAULT'; // Case where no extension are associated
export const DEALERS_ADMINISTRATION = 'DEALERS_ADMINISTRATION'; // Used for displaying all dealers (even inactive)

export const EXTENSIONS_ENUM = {
  AFTER_SALES,
  SALES,
  AUDIT,
  APPOINTMENT,
  CAMERA,
  CHAT,
  TRACK,
  SELF_SERVICE,
  PARTS,
  CAMPAIGN
};

// File extension without self-service
export const FILES_EXTENSIONS_WO_SELF_SERVICE = [AFTER_SALES, SALES, PARTS];
